import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PaginationComponent} from './pagination/pagination.component';
import {ElementsService} from '../elements.service';
import {Subscription} from "rxjs";

// interface iSortStatus{
//   label: string,
//   status : number
// }

@Component({
  selector: 'as-table',
  templateUrl: './tables.component.html',
  styleUrls: ['./tables.component.scss'],

})

export class TablesComponent implements OnInit {

  @ViewChild(PaginationComponent, {static: false}) PaginationComponent: PaginationComponent;
  @ViewChild('tableHeader', {static: false}) tableHeader;
  @ViewChild('thead', {static: false}) thead;
  @ViewChild('table', {static: false}) table;

  @Input() type;
  @Input() showFilter: boolean = true;
  @Input() inlineStyle;
  @Input() overwriteMinHeight: boolean = false;
  @Input() data: any;
  @Input() dataUrl: string;
  @Input() url: string;
  @Input() headers;
  @Input() export: boolean = false;
  @Input() pagination = false;
  @Input() paginationSize;
  @Input() selectable = false;
  @Input() title: string;
  @Input() hidePagination: boolean;
  @Input() itemsPerPage: number;
  @Input() hidePageSize: boolean;
  @Input() itemsToDisplay: number;
  @Input() ajax: boolean = false;
  @Input() filterOnKeys: Array<any>;
  @Input() dataSubscriber;
  @Input() sortingSubscriber;
  @Input() minimalPagination;
  @Input() hideFirstElement: boolean = false;
  @Input() index: string;

  @Output() outputData = new EventEmitter();
  @Output() filteredData = new EventEmitter();
  @Output() outputSelected = new EventEmitter();

  RawHTMLdata: Array<any>[any];
  HTMLheader: Array<any>;
  selectLabel: string = "All"
  selectState: boolean = true;
  unsortedData;
  pageSize: number = 40;
  HTMLdata = [];
  selectedCount: number = 0;
  preloader = true;
  selectedTableData = [];
  isDataEmpty: boolean = false;

  subscriber: Subscription;

  private _gridApi;

  constructor(private http: HttpClient, private ElementsService: ElementsService) {
  }

  ngOnInit() {

    if (this.dataSubscriber != undefined) {

      this.data = [];
      this.subscriber = this.dataSubscriber.subscribe((c) => {

        // this.preloader = true;
        this.isDataEmpty = (c.length == 0);
        this.data = c;
        this.RawHTMLdata = c;

        this.setTableData();
      });
    } else {

      this.RawHTMLdata = this.data;
      this.setTableData();
      // this.preloader = false;
    }

    this.ElementsService.isSearchStateEmitter.subscribe((s) => {
      if (s) {
        this.data = [];
        this.preloader = true;
      }
    })

  }

  updateData(e, source?: string) {

    //coming FROM different components

    this.pageSize = e.length;
    this.pageSize = e.length;

    switch (source) {

      case "sorting" :
        // this.selectedTableData = [];
        if (this.selectedTableData) {
          this.outputSelected.emit(this.selectedTableData)
        }
        this.data = e;
        this.PaginationComponent.RawHTMLdata = e;
        if (!this.ajax) {
          this.PaginationComponent.first();
        } else {
          this.HTMLdata = e;
        }
        break;

      case "typeahead" :
        this.processTypeahead(e)

        break;

      case 'filter' :
        this.processFilter(e);
        break;

      case "pagination" :

        if (!this.isDataEmpty) {

          this.checkIfSelectAllForThisPage(e);

          //processed data
          this.outputData.emit(e);

        } else {
          // this.preloader = false;
        }
        break;

      default :

        this.HTMLdata = e;

    }
  }

  setTableData() {
    this.HTMLheader = this.headers;
    this.unsortedData = this.data;
    // this.updateSortinStatuses(0);
  }

  onGridReady(params) {
    // this._gridApi = params.api;
  }

  onBtnExport() {

    // this._gridApi.exportDataAsCsv();
  }

  handleEvent(index, event) {
    this.HTMLdata[index].selected = !this.HTMLdata[index].selected;

    if (!this.HTMLdata[index].selected) {
      this.selectedCount--;
    } else {
      this.selectedCount++;
    }

    this.onSubmitHTMLtable();

  }

  setSelectLabel() {
    this.selectLabel = (!this.selectState) ? "All" : "None";
  }

  checkIfSelectAllForThisPage(pagedata) {

    //we're just checking the first one, this way we know that all are selected
    if (!this.isDataEmpty && pagedata[0] && this.thead) {
      this.thead.isAllSelected = pagedata[0].selected;
    }

  }

  selectAll(e) {
    //were selecting all on all pages or single page
    let d = (this.hidePagination) ? this.data : this.RawHTMLdata;
    d.map((curr) => {
      curr["selected"] = e.selected;

      if (e.selected == true) {
        if (!this.selectedTableData.includes(curr)) {
          this.selectedTableData.push(curr);
        }
      } else {
        this.selectedTableData.splice(this.selectedTableData.indexOf(curr), 1)
      }
    });
    this.outputSelected.emit(this.selectedTableData)

    // this.onSubmitHTMLtable();
  }

  selectedSingle(payload) {

    this.data.map((curr) => {
      if (curr == payload.item) {

        curr['selected'] = payload.selected;
        if (payload.selected == true) {
          this.selectedTableData.push(curr);
        } else {
          this.selectedTableData.splice(this.selectedTableData.indexOf(curr), 1)
        }
      }
    })

    this.outputSelected.emit(this.selectedTableData)
  }

  onSubmitHTMLtable() {
    let output = this.HTMLdata.reduce((accum, curr) => {
      if (curr.selected) {
        accum.push(curr)
      }

      return accum;
    }, [])

    // this.outputData.emit(output)

  }

  processFilter(e) {
    this.HTMLdata = e;
    this.filteredData.emit(e);
    this.PaginationComponent.RawHTMLdata = e;
    this.PaginationComponent.first();
  }

  processTypeahead(e) {

    this.PaginationComponent.RawHTMLdata = e;

    if (this.ajax) {

      switch (e) {
        case "preloader":
          // this.PaginationComponent.preloader = true;
          break;
        case "clear" :
          this.PaginationComponent.first();
          break;

        default:
          // this.PaginationComponent.preloader = false;
          this.HTMLdata = e;
          break;
      }
    } else {

      this.PaginationComponent.first();
    }
  }

  state(value){

  }

  updateScrollPosition(event) {
    if (event) {
      this.table?.nativeElement.scrollIntoView({behavior: "smooth"})
    }
  }

  ngOnDestroy() {
    this.preloader = false;
    if (this.subscriber) {
      this.subscriber.unsubscribe();
    }
    this.dataSubscriber = undefined;
  }

  ngAfterContentChecked() {

    if (this.data.length > 0) {
      this.preloader = false;
    }

  }

  ngAfterViewInit() {

    setTimeout(() => {

      if (this.data.length == 0) {
        this.preloader = false;
      }
    }, 5000)
  }

}
